module.exports = "<svg viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><g stroke=\"#FFF\" class=\"asda-icon__stroke\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M14.5 18a.5.5 0 001 0v-6.5a.5.5 0 00-1 0V18z\"></path><path d=\"M12 14l2.646-2.646a.5.5 0 01.708 0L18 14\" stroke-width=\"2\" stroke-linecap=\"round\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-vertical-arrow-small.svg
// module id = 730
// module chunks = 0